export const UPDATE_TAG_BATCH = `
  mutation Mutation($input: MutateTagBatchInput!) {
    updateTagBatch(input: $input) {
      id
    }
}`;